import React, { useEffect, useState, useRef } from "react";
import DepartmentTopbar from "./components/DepartmentTopbar";
import DepertmentSidebar from "./components/DepertmentSidebar";
import SuperAdminSidebar from "./components/SuperAdminSidebar";
import Topbar from "./components/Topbar";
import styles from "../../assets/css/Dashboard.module.css";
import { useNavigate } from "react-router-dom";
import { FaDownload, FaEdit, FaEye, FaHistory, FaPlus, FaFilePdf } from "react-icons/fa";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import { Modal } from "react-bootstrap";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';

const parseDate = (str) => {
    if (!str) return null;
    const [day, month, year] = str.split("-");
    if (!day || !month || !year) return null;
    let fullYear = year;
    if (year.length === 2) {
        fullYear = "20" + year;
    }
    return new Date(`${fullYear}-${month}-${day}`);
};

function Expessense() {
    const navigate = useNavigate();
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [reportPeriod, setReportPeriod] = useState({ start: "", end: "" });
    const [tableData, setTableData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const user_name = localStorage.getItem('user_name');
    const user_id = localStorage.getItem('user_id');
    const userType = localStorage.getItem('type');
    const userRole = localStorage.getItem('role');
    const isSuperAdmin = userRole === 'Super_Admin';
    const [formData, setFormData] = useState({
        fund: "",
        title: "",
        description: "",
        bill_copy: null,
        amount: "",
        date: "",
        memo_no: "",
    });
    const [showStatusModal, setShowStatusModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [selectedMemoNo, setSelectedMemoNo] = useState("");
    const [statusFormData, setStatusFormData] = useState({
        date: "",
        department: "",
        type: "",
        final_payment_amount: "",
        unspent_balance: "",
    });
    const [showModal, setShowModal] = useState(false);
    const [processingHistory, setProcessingHistory] = useState([]);
    const [historyLoading, setHistoryLoading] = useState(false);
    const [fundList, setFundList] = useState([]);
    const [departmentList, setDepartmentList] = useState([]);
    const [userList, setUserList] = useState([]);
    const [activeTab, setActiveTab] = useState('all');
    const tableRef = useRef();
    const [showActionModal, setShowActionModal] = useState(false);
    const [actionType, setActionType] = useState("");
    const [actionFormData, setActionFormData] = useState({
        date: new Date().toISOString().slice(0, 10),
        department: "",
        user: "",
    });
    const [actionRow, setActionRow] = useState(null);
    // Add state for unspent balance error
    const [unspentError, setUnspentError] = useState("");
    const [editingRowId, setEditingRowId] = useState(null);
    const [editingField, setEditingField] = useState(null); // 'all' or 'amount'
    const [editFormData, setEditFormData] = useState({
        fund: "",
        title: "",
        description: "",
        bill_copy: null,
        amount: "",
        date: "",
        memo_no: "",
    });

    const billCopyRef = useRef();

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const token = localStorage.getItem("token");
                const response = await fetch(
                    `${process.env.REACT_APP_SUPER_ADMIN_API_URL}/expessense_list.php`,
                    {
                        method: "GET",
                        headers: {
                            "Authorization": `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );
                const data = await response.json();
                if (data.success && Array.isArray(data.data)) {
                    // Sort by date descending (latest first)
                    data.data.sort((a, b) => new Date(b.date) - new Date(a.date));
                    setTableData(data.data);
                    setFilteredData(data.data);
                } else {
                    setTableData([]);
                    setFilteredData([]);
                }
            } catch (error) {
                setTableData([]);
                setFilteredData([]);
            }
            setLoading(false);
        };

        const fetchFundList = async () => {
            try {
                const token = localStorage.getItem("token");
                const response = await fetch(
                    `${process.env.REACT_APP_SUPER_ADMIN_API_URL}/fundlist.php`,
                    {
                        method: "GET",
                        headers: {
                            "Authorization": `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );
                const data = await response.json();
                if (data.success) {
                    setFundList(data.funds || []);
                }
            } catch (error) {
                console.error("Error fetching fund list:", error);
            }
        };

        const fetchDepartmentList = async () => {
            try {
                const token = localStorage.getItem("token");
                const response = await fetch(
                    `${process.env.REACT_APP_SUPER_ADMIN_API_URL}/departmentlist.php`,
                    {
                        method: "GET",
                        headers: {
                            "Authorization": `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );
                const data = await response.json();
                if (data.success) {
                    // Filter out the department that matches localStorage type
                    const filteredDepartments = data.departments.filter(
                        dept => dept.department_name !== userType
                    );
                    setDepartmentList(filteredDepartments || []);
                }
            } catch (error) {
                console.error("Error fetching department list:", error);
            }
        };

        const fetchUserList = async () => {
            try {
                const token = localStorage.getItem("token");
                const response = await fetch(
                    `${process.env.REACT_APP_SUPER_ADMIN_API_URL}/userlist.php`,
                    {
                        method: "GET",
                        headers: {
                            "Authorization": `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );
                const data = await response.json();
                if (Array.isArray(data)) {
                    setUserList(data || []);
                }
            } catch (error) {
                console.error("Error fetching user list:", error);
            }
        };

        fetchData();
        fetchFundList();
        fetchDepartmentList();
        fetchUserList();
        return () => {
            if ($.fn.DataTable.isDataTable("#pwdTable")) {
                $("#pwdTable").DataTable().destroy();
            }
        };
    }, []);

    // Helper to destroy DataTable safely
    const destroyDataTable = () => {
        if ($.fn.DataTable.isDataTable('#pwdTable')) {
            $('#pwdTable').DataTable().destroy();
        }
    };

    useEffect(() => {
        if (!loading && filteredData.length > 0) {
            // Only initialize if not already initialized
            if (!$.fn.DataTable.isDataTable('#pwdTable')) {
                $('#pwdTable').DataTable({
                    responsive: true,
                    pageLength: 10,
                    lengthMenu: [
                        [10, 25, 50, -1],
                        [10, 25, 50, "All"],
                    ],
                    order: [[1, "desc"]],
                    language: {
                        search: "Search:",
                        lengthMenu: "Show _MENU_ entries",
                        info: "Showing _START_ to _END_ of _TOTAL_ entries",
                        infoEmpty: "Showing 0 to 0 of 0 entries",
                        infoFiltered: "(filtered from _MAX_ total entries)",
                        paginate: {
                            first: "First",
                            last: "Last",
                            next: "Next",
                            previous: "Previous",
                        },
                    },
                });
            }
        }
        return () => {
            destroyDataTable();
        };
    }, [filteredData, loading]);

    const handleFilter = () => {
        if (!startDate || !endDate) return;
        destroyDataTable();

        const start = new Date(startDate);
        const end = new Date(endDate);
        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);

        if (!Array.isArray(tableData)) {
            setFilteredData([]);
            setReportPeriod({ start: startDate, end: endDate });
            return;
        }

        const filtered = tableData.filter((item) => {
            if (!item.date) return false;
            const itemDate = new Date(item.date);
            itemDate.setHours(0, 0, 0, 0);
            return itemDate >= start && itemDate <= end;
        });

        setFilteredData(filtered);
        setReportPeriod({ start: startDate, end: endDate });
    };

    const handleReset = () => {
        destroyDataTable();
        setStartDate("");
        setEndDate("");
        setReportPeriod({ start: "", end: "" });
        setFilteredData(Array.isArray(tableData) ? tableData : []);
        setFormData({
            fund: "",
            title: "",
            description: "",
            bill_copy: null,
            amount: "",
            date: "",
            memo_no: "",
        });
    };

    const handleTabFilter = (tab) => {
        setActiveTab(tab);
        destroyDataTable();

        if (!Array.isArray(tableData)) {
            setFilteredData([]);
            return;
        }

        let filtered = tableData;

        if (tab === 'pending') {
            filtered = tableData.filter(item => (item.final_status || '').toLowerCase().trim() === 'pending');
        } else if (tab === 'complete') {
            filtered = tableData.filter(item => (item.final_status || '').toLowerCase().trim() === 'complete');
        }

        setFilteredData(filtered);
    };

    const handleProcessingHistory = async (id, memoNo) => {
        setSelectedMemoNo(memoNo);
        setShowModal(true);
        setHistoryLoading(true);
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(
                `${process.env.REACT_APP_SUPER_ADMIN_API_URL}/singlepwdhistory.php`,
                {
                    method: "POST",
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ pwd_id: id }),
                }
            );
            const data = await response.json();
            if (data.success && Array.isArray(data.history)) {
                setProcessingHistory(data.history);
            } else {
                setProcessingHistory([]);
            }
        } catch (error) {
            console.error("Error fetching processing history:", error);
            setProcessingHistory([]);
        }
        setHistoryLoading(false);
    };

    const closeModal = () => {
        setShowModal(false);
        setProcessingHistory([]);
        setSelectedMemoNo("");
    };

    const handleViewDetails = (row) => {
        handleProcessingHistory(row.id, row.memo_no);
    };

    const handleChangeStatus = (id, memoNo) => {
        const row = filteredData.find(item => item.id === id);
        setSelectedId(id);
        setSelectedMemoNo(memoNo);
        setShowStatusModal(true);
        setStatusFormData({
            type: (row?.final_status || '').toLowerCase().trim(),
            final_payment_amount: row?.final_payment_amount || '',
            unspent_balance: row?.unspent_balance || '',
        });
    };

    const handleStatusChange = (e) => {
        const { name, value } = e.target;
        setStatusFormData((prev) => {
            let updated = { ...prev, [name]: value };
            // Auto-calculate unspent_balance if final_payment_amount changes
            if (name === 'final_payment_amount') {
                // Find the selected row's allotment_amount
                const row = filteredData.find(item => item.id === selectedId);
                const allotmentAmount = parseFloat(row?.alotment_amount) || 0;
                const finalPaymentAmount = parseFloat(value) || 0;
                let unspent = allotmentAmount - finalPaymentAmount;
                if (unspent < 0) unspent = 0;
                updated.unspent_balance = unspent === 0 ? "0" : unspent.toFixed(2).replace(/^-/, "");
            }
            return updated;
        });
    };

    const handleStatusSubmit = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(
                `${process.env.REACT_APP_SUPER_ADMIN_API_URL}SAEchangestatus.php`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        pwd_id: selectedId,
                        final_status: statusFormData.type,
                        final_payment_amount: statusFormData.final_payment_amount,
                        unspent_balance: statusFormData.unspent_balance,
                    }),
                }
            );

            const data = await response.json();

            if (data.success) {
                // Refresh the data
                const refreshResponse = await fetch(
                    `${process.env.REACT_APP_SUPER_ADMIN_API_URL}/pwd-list.php`,
                    {
                        method: "GET",
                        headers: {
                            "Authorization": `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );
                const refreshData = await refreshResponse.json();

                if (Array.isArray(refreshData)) {
                    // Sort by memo_date descending (latest first)
                    refreshData.sort((a, b) => {
                        const dateA = new Date(a.memo_date);
                        const dateB = new Date(b.memo_date);
                        return dateB - dateA;
                    });
                    setTableData(refreshData);
                    setFilteredData(refreshData);
                } else {
                    console.warn("API returned non-array data for refresh:", refreshData);
                    setTableData([]);
                    setFilteredData([]);
                }

                setShowStatusModal(false);
                setStatusFormData({
                    type: "",
                    final_payment_amount: "",
                    unspent_balance: "",
                });
                toast.success("Status updated successfully!");
            } else {
                toast.error((data.message || "Failed to update status.").replace('Insafesecent', 'Sufficient'));
            }
        } catch (error) {
            console.error("Error updating status:", error);
            toast.error("Error updating status. Please try again.");
        }
    };

    const handleAddNewChange = (e) => {
        const { name, value, type, files } = e.target;
        let updatedFormData = {
            ...formData,
            [name]: type === "file" ? files[0] : value,
        };

        if (name === "department") {
            updatedFormData = {
                ...updatedFormData,
                departmentbaseuser: "",
            };
        }

        if (name === "less_amount" && value) {
            updatedFormData = {
                ...updatedFormData,
                [name]: value,
                above_amount: "",
            };
        } else if (name === "above_amount" && value) {
            updatedFormData = {
                ...updatedFormData,
                [name]: value,
                less_amount: "",
            };
        }

        if (name === "estimet_amount" || name === "less_amount" || name === "above_amount") {
            const currentValue = parseFloat(value) || 0;
            const estimateAmount = name === "estimet_amount" ? currentValue : (parseFloat(updatedFormData.estimet_amount) || 0);
            const lessPercentage = name === "less_amount" ? currentValue : (parseFloat(updatedFormData.less_amount) || 0);
            const abovePercentage = name === "above_amount" ? currentValue : (parseFloat(updatedFormData.above_amount) || 0);
            let finalAmount = estimateAmount;
            if (lessPercentage > 0) {
                finalAmount = estimateAmount - (estimateAmount * lessPercentage / 100);
            } else if (abovePercentage > 0) {
                finalAmount = estimateAmount + (estimateAmount * abovePercentage / 100);
            }
            updatedFormData.final_amount = Number.isInteger(finalAmount) ? String(finalAmount) : finalAmount.toString();
        }

        // Only auto-calculate unspent_balance when final_payment_amount changes
        if (name === "final_payment_amount") {
            const alotmentAmount = parseFloat(updatedFormData.alotment_amount) || 0;
            const finalPaymentAmount = parseFloat(value) || 0;
            let unspent = alotmentAmount - finalPaymentAmount;
            if (unspent < 0) {
                setUnspentError("Final Payment Amount cannot exceed Alotment Amount");
                unspent = 0;
            } else {
                setUnspentError("");
            }
            updatedFormData.unspent_balance = unspent === 0 ? "0" : unspent.toFixed(2).replace(/^-/, "");
        }

        setFormData(updatedFormData);
    };

    const getFilteredUsers = () => {
        if (!formData.department) return [];

        return userList.filter(user =>
            user.department_id === formData.department
        );
    };

    const handleAddNewSubmit = async (e) => {
        e.preventDefault();
        destroyDataTable();
        try {
            const formDataToSend = new FormData();
            formDataToSend.append("fund_id", formData.fund);
            formDataToSend.append("title", formData.title);
            formDataToSend.append("description", formData.description);
            if (formData.bill_copy) {
                formDataToSend.append("bill_order_copy", formData.bill_copy);
            }
            formDataToSend.append("amount", formData.amount);
            formDataToSend.append("date", formData.date);
            formDataToSend.append("memo_no", formData.memo_no);

            const token = localStorage.getItem("token");
            const url = `${process.env.REACT_APP_SUPER_ADMIN_API_URL}/expessense_add.php`;
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${token}`,
                },
                body: formDataToSend,
            });

            const data = await response.json();

            if (data.success) {
                // Refresh the data
                const fetchData = async () => {
                    setLoading(true);
                    try {
                        const token = localStorage.getItem("token");
                        const response = await fetch(
                            `${process.env.REACT_APP_SUPER_ADMIN_API_URL}/expessense_list.php`,
                            {
                                method: "GET",
                                headers: {
                                    "Authorization": `Bearer ${token}`,
                                    "Content-Type": "application/json",
                                },
                            }
                        );
                        const data = await response.json();
                        if (data.success && Array.isArray(data.data)) {
                            data.data.sort((a, b) => new Date(b.date) - new Date(a.date));
                            setTableData(data.data);
                            setFilteredData(data.data);
                        } else {
                            setTableData([]);
                            setFilteredData([]);
                        }
                    } catch (error) {
                        setTableData([]);
                        setFilteredData([]);
                    }
                    setLoading(false);
                };
                await fetchData();
                setShowAddModal(false);
                setIsEditMode(false);
                setEditingId(null);
                setFormData({
                    fund: "",
                    title: "",
                    description: "",
                    bill_copy: null,
                    amount: "",
                    date: "",
                    memo_no: "",
                });
                toast.success("Expense added successfully!");
            } else {
                toast.error(data.message || "Failed to save expense.");
            }
        } catch (error) {
            toast.error("Error submitting data. Please try again.");
        }
    };

    // Add functions to calculate counts for each tab
    const getPendingCount = () => {
        if (!Array.isArray(tableData)) return 0;
        return tableData.filter(item => (item.final_status || '').toLowerCase().trim() === 'pending').length;
    };

    const getCompleteCount = () => {
        if (!Array.isArray(tableData)) return 0;
        return tableData.filter(item => (item.final_status || '').toLowerCase().trim() === 'complete').length;
    };

    const getAllCount = () => {
        return Array.isArray(tableData) ? tableData.length : 0;
    };

    // Add handler functions for Forward and Revert buttons
    const handleForward = (row) => {
        setActionType("forward");
        setActionRow(row);
        setActionFormData({
            date: new Date().toISOString().slice(0, 10),
            department: "",
            user: "",
        });
        setShowActionModal(true);
    };

    const handleRevert = (row) => {
        setActionType("revert");
        setActionRow(row);
        setActionFormData({
            date: new Date().toISOString().slice(0, 10),
            department: "",
            user: "",
        });
        setShowActionModal(true);
    };

    const handleActionFormChange = (e) => {
        const { name, value } = e.target;
        setActionFormData((prev) => ({
            ...prev,
            [name]: value,
            ...(name === "department" ? { user: "" } : {}),
        }));
    };

    const getActionFilteredUsers = () => {
        if (!actionFormData.department) return [];
        return userList.filter(user => user.department_id === actionFormData.department);
    };

    const handleActionSubmit = async (e) => {
        e.preventDefault();
        if (!actionRow || !actionFormData.department || !actionFormData.user) {
            alert("Please select all fields.");
            return;
        }
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(
                `${process.env.REACT_APP_SUPER_ADMIN_API_URL}/pwd-forward-revert.php`,
                {
                    method: "POST",
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        pwd_id: actionRow.id,
                        date: actionFormData.date,
                        department_id: actionFormData.department,
                        user_id: actionFormData.user,
                        to_status: actionType,
                        by_id: user_id
                    }),
                }
            );
            const data = await response.json();
            if (data.success) {
                // Refresh the table data
                const refreshResponse = await fetch(
                    `${process.env.REACT_APP_SUPER_ADMIN_API_URL}/pwd-list.php`,
                    {
                        method: "GET",
                        headers: {
                            "Authorization": `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );
                const refreshData = await refreshResponse.json();
                setTableData(Array.isArray(refreshData) ? refreshData : []);
                setFilteredData(Array.isArray(refreshData) ? refreshData : []);
                setShowActionModal(false);
                toast.success(data.message || `${actionType === 'forward' ? 'Forwarded' : 'Reverted'} successfully!`);
            } else {
                toast.error((data.message || "Failed to update status.").replace('Insafesecent', 'Sufficient'));
            }
        } catch (error) {
            console.error("Error submitting action:", error);
            toast.error("Error submitting action. Please try again.");
        }
    };

    const handleEditClick = (row) => {
        setEditingRowId(row.id);
        setEditingField('all');
        setEditFormData({
            fund: row.fund_id || "",
            title: row.title || "",
            description: row.description || "",
            bill_copy: null,
            date: row.date || "",
            memo_no: row.memo_no || "",
            amount: row.amount || "",
        });
    };

    const handleCancelEdit = () => {
        setEditingRowId(null);
        setEditingField(null);
        setEditFormData({
            fund: "",
            title: "",
            description: "",
            bill_copy: null,
            date: "",
            memo_no: "",
            amount: "",
        });
    };

    const handleEditFormChange = (e) => {
        const { name, value, type, files } = e.target;
        setEditFormData((prev) => ({
            ...prev,
            [name]: type === "file" ? files[0] : value,
        }));
    };

    const handleSaveEdit = async () => {
        destroyDataTable();
        try {
            const formDataToSend = new FormData();
            formDataToSend.append("id", editingRowId);
            formDataToSend.append("fund_id", editFormData.fund);
            formDataToSend.append("title", editFormData.title);
            formDataToSend.append("description", editFormData.description);
            if (editFormData.bill_copy) {
                formDataToSend.append("bill_order_copy", editFormData.bill_copy);
            }
            formDataToSend.append("date", editFormData.date);
            formDataToSend.append("memo_no", editFormData.memo_no);
            formDataToSend.append("amount", editFormData.amount);

            const token = localStorage.getItem("token");
            const url = `${process.env.REACT_APP_SUPER_ADMIN_API_URL}/editexpessense.php`;
            
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${token}`,
                },
                body: formDataToSend,
            });

            const data = await response.json();

            if (data.success) {
                // Refresh the data
                const fetchData = async () => {
                    setLoading(true);
                    try {
                        const token = localStorage.getItem("token");
                        const response = await fetch(
                            `${process.env.REACT_APP_SUPER_ADMIN_API_URL}/expessense_list.php`,
                            {
                                method: "GET",
                                headers: {
                                    "Authorization": `Bearer ${token}`,
                                    "Content-Type": "application/json",
                                },
                            }
                        );
                        const data = await response.json();
                        if (data.success && Array.isArray(data.data)) {
                            data.data.sort((a, b) => new Date(b.date) - new Date(a.date));
                            setTableData(data.data);
                            setFilteredData(data.data);
                        } else {
                            setTableData([]);
                            setFilteredData([]);
                        }
                    } catch (error) {
                        setTableData([]);
                        setFilteredData([]);
                    }
                    setLoading(false);
                };
                await fetchData();
                handleCancelEdit();
                
                // Reinitialize DataTable after data refresh
                setTimeout(() => {
                    if (!$.fn.DataTable.isDataTable('#pwdTable')) {
                        $('#pwdTable').DataTable({
                            responsive: true,
                            pageLength: 10,
                            lengthMenu: [
                                [10, 25, 50, -1],
                                [10, 25, 50, "All"],
                            ],
                            order: [[1, "desc"]],
                            language: {
                                search: "Search:",
                                lengthMenu: "Show _MENU_ entries",
                                info: "Showing _START_ to _END_ of _TOTAL_ entries",
                                infoEmpty: "Showing 0 to 0 of 0 entries",
                                infoFiltered: "(filtered from _MAX_ total entries)",
                                paginate: {
                                    first: "First",
                                    last: "Last",
                                    next: "Next",
                                    previous: "Previous",
                                },
                            },
                        });
                    }
                }, 100);
                
                toast.success("Expense updated successfully!");
            } else {
                toast.error(data.message || "Failed to save expense.");
            }
        } catch (error) {
            toast.error("Error submitting data. Please try again.");
        }
    };

    return (
        <>
            <DepartmentTopbar />
            <div className="d-flex">
                <DepertmentSidebar />
                <div className={styles.dashboardContainer}>
                    <div className="d-flex align-items-center mb-4">
                        <h2
                            className="mb-0"
                            style={{
                                color: "#2c3e50",
                                fontWeight: "500",
                                fontSize: "1.5rem",
                            }}
                        >
                            Expessense Reports
                        </h2>
                    </div>
                    <div
                        className="card mb-4"
                        style={{ borderRadius: "8px", backgroundColor: "#fff" }}
                    >
                        <div className="card-body p-3">
                            <div className="d-flex justify-content-between align-items-start mb-3">
                                <div className="row g-3 align-items-end flex-grow-1">
                                    <div className="col-auto">
                                        <label className="form-label small text-muted mb-1">
                                            Start Date
                                        </label>
                                        <input
                                            type="date"
                                            className="form-control form-control-sm"
                                            value={startDate}
                                            onChange={(e) => setStartDate(e.target.value)}
                                            style={{ width: "160px", borderColor: "#dee2e6" }}
                                        />
                                    </div>
                                    <div className="col-auto">
                                        <label className="form-label small text-muted mb-1">
                                            End Date
                                        </label>
                                        <input
                                            type="date"
                                            className="form-control form-control-sm"
                                            value={endDate}
                                            onChange={(e) => setEndDate(e.target.value)}
                                            style={{ width: "160px", borderColor: "#dee2e6" }}
                                        />
                                    </div>
                                    <div className="col-auto">
                                        <button
                                            className="btn btn-primary btn-sm px-4"
                                            onClick={handleFilter}
                                            disabled={!startDate || !endDate}
                                        >
                                            Apply Filter
                                        </button>
                                        <button
                                            className="btn btn-outline-secondary btn-sm px-3 ms-2"
                                            onClick={handleReset}
                                        >
                                            Reset
                                        </button>
                                    </div>
                                </div>
                                <button
                                    className="btn btn-primary btn-sm"
                                    onClick={() => setShowAddModal(true)}
                                >
                                    <FaPlus /> Add New
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="card">
                        <div className="card-body p-2">
                            <div className="mb-3">
                                <ul className="nav nav-tabs" id="pwdTab" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className={`nav-link ${activeTab === 'all' ? 'active' : ''}`}
                                            type="button"
                                            onClick={() => handleTabFilter('all')}
                                            style={{
                                                border: 'none',
                                                backgroundColor: activeTab === 'all' ? '#007bff' : 'transparent',
                                                color: activeTab === 'all' ? 'white' : '#6c757d',
                                                padding: '8px 16px',
                                                borderRadius: '4px 4px 0 0',
                                                marginRight: '4px',
                                                fontWeight: activeTab === 'all' ? '500' : '400'
                                            }}
                                        >
                                            All ({getAllCount()})
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className={`nav-link ${activeTab === 'pending' ? 'active' : ''}`}
                                            type="button"
                                            onClick={() => handleTabFilter('pending')}
                                            style={{
                                                border: 'none',
                                                backgroundColor: activeTab === 'pending' ? '#007bff' : 'transparent',
                                                color: activeTab === 'pending' ? 'white' : '#6c757d',
                                                padding: '8px 16px',
                                                borderRadius: '4px 4px 0 0',
                                                marginRight: '4px',
                                                fontWeight: activeTab === 'pending' ? '500' : '400'
                                            }}
                                        >
                                            Pending ({getPendingCount()})
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className={`nav-link ${activeTab === 'complete' ? 'active' : ''}`}
                                            type="button"
                                            onClick={() => handleTabFilter('complete')}
                                            style={{
                                                border: 'none',
                                                backgroundColor: activeTab === 'complete' ? '#007bff' : 'transparent',
                                                color: activeTab === 'complete' ? 'white' : '#6c757d',
                                                padding: '8px 16px',
                                                borderRadius: '4px 4px 0 0',
                                                marginRight: '4px',
                                                fontWeight: activeTab === 'complete' ? '500' : '400'
                                            }}
                                        >
                                            Complete ({getCompleteCount()})
                                        </button>
                                    </li>
                                </ul>
                            </div>
                            <div className="table-responsive">
                                <table
                                    ref={tableRef}
                                    id="pwdTable"
                                    className="table table-bordered align-middle mb-0"
                                >
                                    <thead className="table-light">
                                        <tr>
                                            <th className="text-start">Memo No</th>
                                            <th className="text-start">Date</th>
                                            <th className="text-start">Fund</th>
                                            <th className="text-start">Title</th>
                                            <th className="text-start">Description</th>
                                            <th className="text-start">Bill Copy</th>
                                            <th className="text-start" style={{ width: 100, verticalAlign: 'middle' }}>Amount</th>
                                            <th className="text-start" style={{ width: 120, verticalAlign: 'middle' }}>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td colSpan="8" className="text-center py-4">
                                                    <div className="spinner-border text-primary" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        ) : filteredData.length === 0 ? (
                                            <tr>
                                                <td colSpan="8" className="text-center text-muted py-4">
                                                    No data found for the selected date range
                                                </td>
                                            </tr>
                                        ) : (
                                            filteredData.map((row, index) => (
                                                <tr key={index}>
                                                    <td className="text-start">
                                                        {editingRowId === row.id && editingField === 'all' ? (
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                name="memo_no"
                                                                value={editFormData.memo_no}
                                                                onChange={handleEditFormChange}
                                                            />
                                                        ) : (
                                                            row.memo_no
                                                        )}
                                                    </td>
                                                    <td className="text-start" style={{ verticalAlign: 'middle' }}>
                                                        {editingRowId === row.id && editingField === 'all' ? (
                                                            <input
                                                                type="date"
                                                                className="form-control form-control-sm"
                                                                name="date"
                                                                value={editFormData.date}
                                                                onChange={handleEditFormChange}
                                                            />
                                                        ) : (
                                                            row.date
                                                        )}
                                                    </td>
                                                    <td className="text-start" style={{ verticalAlign: 'middle' }}>
                                                        {editingRowId === row.id && editingField === 'all' ? (
                                                            <select
                                                                className="form-control form-control-sm"
                                                                name="fund"
                                                                value={editFormData.fund}
                                                                onChange={handleEditFormChange}
                                                            >
                                                                <option value="">--Select Fund--</option>
                                                                {fundList.map((fund) => (
                                                                    <option className="text-capitalize" key={fund.id} value={fund.id}>
                                                                        {fund.fund_name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        ) : (
                                                            row.fund_name
                                                        )}
                                                    </td>
                                                    <td className="text-start" style={{ verticalAlign: 'middle' }}>
                                                        {editingRowId === row.id && editingField === 'all' ? (
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                name="title"
                                                                value={editFormData.title}
                                                                onChange={handleEditFormChange}
                                                            />
                                                        ) : (
                                                            row.title
                                                        )}
                                                    </td>
                                                    <td className="text-start" style={{ maxWidth: 250, whiteSpace: 'normal', wordBreak: 'break-word', verticalAlign: 'middle' }}>
                                                        {editingRowId === row.id && editingField === 'all' ? (
                                                            <textarea
                                                                className="form-control form-control-sm"
                                                                name="description"
                                                                value={editFormData.description}
                                                                onChange={handleEditFormChange}
                                                                rows={2}
                                                            />
                                                        ) : (
                                                            row.description
                                                        )}
                                                    </td>
                                                    <td className="text-start" style={{ verticalAlign: 'middle' }}>
                                                        {editingRowId === row.id && editingField === 'all' ? (
                                                            <div className="d-flex align-items-center gap-2">
                                                                <input
                                                                    type="file"
                                                                    ref={billCopyRef}
                                                                    style={{ display: 'none' }}
                                                                    name="bill_copy"
                                                                    onChange={handleEditFormChange}
                                                                    accept="image/*,.pdf"
                                                                />
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-outline-secondary btn-sm"
                                                                    onClick={() => billCopyRef.current?.click()}
                                                                    title="Select Bill Copy"
                                                                >
                                                                    <FaFilePdf />
                                                                </button>
                                                                {editFormData.bill_copy && (
                                                                    <small className="text-success">
                                                                        <FaFilePdf className="me-1" />
                                                                        Selected
                                                                    </small>
                                                                )}
                                                            </div>
                                                        ) : (
                                                            row.bill_order_copy ? (
                                                                <a
                                                                    href={`${process.env.REACT_APP_SUPER_ADMIN_API_URL}${row.bill_order_copy}`}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="btn btn-sm btn-outline-primary"
                                                                    title="Download Bill Copy"
                                                                >
                                                                    <FaDownload />
                                                                </a>
                                                            ) : (
                                                                <span className="badge bg-secondary">N/A</span>
                                                            )
                                                        )}
                                                    </td>
                                                    <td className="text-start" style={{ verticalAlign: 'middle' }}>
                                                        {row.amount}
                                                    </td>
                                                    <td className="text-start" style={{ verticalAlign: 'middle' }}>
                                                        <div className="d-flex gap-2 justify-content-center">
                                                            {editingRowId === row.id ? (
                                                                <>
                                                                    <button className="btn btn-success btn-sm" onClick={handleSaveEdit}>
                                                                        Save
                                                                    </button>
                                                                    <button className="btn btn-secondary btn-sm" onClick={handleCancelEdit}>
                                                                        Cancel
                                                                    </button>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <button className="btn btn-warning btn-sm" onClick={() => handleEditClick(row)} title="Edit">
                                                                        <FaEdit />
                                                                    </button>
                                                                    <button className="btn btn-info btn-sm" onClick={() => handleViewDetails(row)}>
                                                                        <FaEye />
                                                                    </button>
                                                                </>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <div className="p-3 border-top">
                                <p className="mb-0 text-muted" style={{ fontSize: "0.875rem", borderLeft: "3px solid #007bff", paddingLeft: "10px" }}>
                                    <i className="far fa-calendar-alt me-2"></i>
                                    Report generated for the period: {reportPeriod.start || "-"} to {reportPeriod.end || "-"}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Processing History Modal */}
            {showModal && (
                <div className="modal fade show " style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}>
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content p-0" style={{ backgroundColor: '#f8f9fb', borderRadius: 12, boxShadow: '0 12px 24px rgba(0,0,0,0.12)' }}>
                            {/* Card-style colored header */}
                            <div style={{ backgroundColor: '#1976d2', borderTopLeftRadius: 12, borderTopRightRadius: 12, padding: '18px 32px', borderBottom: '2px solid #1565c0', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <h5 className="modal-title mb-0" style={{ color: '#fff', fontWeight: 700, fontSize: '1.25rem', display: 'flex', alignItems: 'center' }}>
                                    <i className="fas fa-history" style={{ marginRight: 10, color: '#fff', fontSize: '1.3rem' }}></i>
                                    Work Order No - {selectedMemoNo}
                                </h5>
                                <button type="button" className="btn-close btn-close-white" onClick={closeModal} style={{ backgroundColor: '#fff', border: '1px solid #dee2e6', borderRadius: '50%', width: 22, height: 22, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.2rem', color: '#6c757d' }}></button>
                            </div>
                            <div className="modal-body" style={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto', background: '#f8f9fb', padding: '32px 24px' }}>
                                {historyLoading ? (
                                    <div className="text-center py-4">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                ) : processingHistory?.length === 0 ? (
                                    <div className="text-center py-4 text-muted">No processing history found</div>
                                ) : (
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-striped align-middle">
                                            <thead className="table-dark">
                                                <tr style={{ textTransform: 'capitalize' }}>
                                                    <th>Department Name</th>
                                                    <th>Concerned Name</th>
                                                    <th>Date</th>
                                                    <th>Type</th>
                                                    <th>Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {processingHistory.map((history, index) => {
                                                    const showToStatus = history.to_status && history.to_status.trim() !== '';
                                                    return (
                                                        <tr key={index} style={{ textTransform: 'capitalize' }}>
                                                            <td>{history.department_name}</td>
                                                            <td>{history.user_name}</td>
                                                            <td>{history.creating_date}</td>
                                                            <td>{history.type}</td>
                                                            {showToStatus ? (
                                                                <td>
                                                                    <span style={{ textTransform: 'capitalize', fontSize: '1em' }}>{history.to_status} by {history.by_user_name}</span>
                                                                </td>
                                                            ) : null}
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>

                        </div>
                    </div>
                </div>
            )}

            {/* Add New Large Modal */}
            {showAddModal && (
                <div
                    className="modal fade show"
                    style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
                    tabIndex="-1"
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header" style={{ padding: "12px 20px" }}>
                                <h5
                                    className="modal-title"
                                    style={{
                                        color: "#2c3e50",
                                        fontWeight: 500,
                                        fontSize: "1.2rem",
                                    }}
                                >
                                    {isEditMode ? "Edit Document" : "Add New File"}
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => {
                                        setShowAddModal(false);
                                        setIsEditMode(false);
                                        setEditingId(null);
                                        setFormData({
                                            fund: "",
                                            title: "",
                                            description: "",
                                            bill_copy: null,
                                            amount: "",
                                            date: "",
                                            memo_no: "",
                                        });
                                    }}
                                ></button>
                            </div>

                            <form onSubmit={handleAddNewSubmit}>
                                <div
                                    className="modal-body"
                                    style={{ padding: "18px 20px 10px 20px" }}
                                >
                                    <div className="container-fluid">
                                        <div className="row g-3">
                                            <div className="col-12">
                                                <label
                                                    className="form-label fw-medium mb-1"
                                                    style={{ color: "#495057", fontSize: "0.95rem" }}
                                                >
                                                    Memo No
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm mb-2"
                                                    name="memo_no"
                                                    value={formData.memo_no}
                                                    onChange={handleAddNewChange}
                                                    
                                                />
                                            </div>
                                            <div className="col-12">
                                                <label
                                                    className="form-label fw-medium mb-1"
                                                    style={{ color: "#495057", fontSize: "0.95rem" }}
                                                >
                                                    Fund
                                                </label>
                                                <select
                                                    className="form-control form-control-sm mb-2"
                                                    name="fund"
                                                    value={formData.fund}
                                                    onChange={handleAddNewChange}
                                                >
                                                    <option value="">--Select Fund--</option>
                                                    {fundList.map((fund) => (
                                                        <option className="text-capitalize" key={fund.id} value={fund.id}>
                                                            {fund.fund_name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-12">
                                                <label
                                                    className="form-label fw-medium mb-1"
                                                    style={{ color: "#495057", fontSize: "0.95rem" }}
                                                >
                                                    Title
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm mb-2"
                                                    name="title"
                                                    value={formData.title}
                                                    onChange={handleAddNewChange}
                                                />
                                            </div>
                                            <div className="col-12">
                                                <label
                                                    className="form-label fw-medium mb-1"
                                                    style={{ color: "#495057", fontSize: "0.95rem" }}
                                                >
                                                    Description
                                                </label>
                                                <textarea
                                                    className="form-control form-control-sm mb-2"
                                                    name="description"
                                                    value={formData.description}
                                                    onChange={handleAddNewChange}
                                                    rows={3}
                                                />
                                            </div>
                                            <div className="col-12">
                                                <label
                                                    className="form-label fw-medium mb-1"
                                                    style={{ color: "#495057", fontSize: "0.95rem" }}
                                                >
                                                    Bill Copy / Order Copy
                                                </label>
                                                <input
                                                    type="file"
                                                    className="form-control form-control-sm mb-2"
                                                    name="bill_copy"
                                                    onChange={handleAddNewChange}
                                                    accept="image/*,.pdf"
                                                />
                                            </div>
                                            <div className="col-12">
                                                <label
                                                    className="form-label fw-medium mb-1"
                                                    style={{ color: "#495057", fontSize: "0.95rem" }}
                                                >
                                                    Amount
                                                </label>
                                                <input
                                                    type="number"
                                                    className="form-control form-control-sm mb-2"
                                                    name="amount"
                                                    value={formData.amount}
                                                    onChange={handleAddNewChange}
                                                />
                                            </div>
                                            <div className="col-12">
                                                <label
                                                    className="form-label fw-medium mb-1"
                                                    style={{ color: "#495057", fontSize: "0.95rem" }}
                                                >
                                                    Date
                                                </label>
                                                <input
                                                    type="date"
                                                    className="form-control form-control-sm mb-2"
                                                    name="date"
                                                    value={formData.date}
                                                    onChange={handleAddNewChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer" style={{ padding: "10px 20px" }}>
                                    <button
                                        type="button"
                                        className="btn btn-secondary btn-sm"
                                        onClick={() => {
                                            setShowAddModal(false);
                                            setIsEditMode(false);
                                            setEditingId(null);
                                            setFormData({
                                                fund: "",
                                                title: "",
                                                description: "",
                                                bill_copy: null,
                                                amount: "",
                                                date: "",
                                                memo_no: "",
                                            });
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button type="submit" className="btn btn-primary btn-sm">
                                        {isEditMode ? "Update" : "Submit"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {/* Status Modal */}
            {showStatusModal && (
                <div
                    className="modal fade show"
                    style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
                    tabIndex="-1"
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header" style={{ padding: "12px 20px" }}>
                                <h5
                                    className="modal-title"
                                    style={{
                                        color: "#2c3e50",
                                        fontWeight: 500,
                                        fontSize: "1.2rem",
                                    }}
                                >
                                    Update Status for Memo No: {selectedMemoNo}
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => {
                                        setShowStatusModal(false);
                                        setStatusFormData({
                                            type: "",
                                            final_payment_amount: "",
                                            unspent_balance: "",
                                        });
                                    }}
                                ></button>
                            </div>

                            <form onSubmit={handleStatusSubmit}>
                                <div
                                    className="modal-body"
                                    style={{ padding: "18px 20px 10px 20px" }}
                                >
                                    <div className="container-fluid">
                                        <div className="row g-2">
                                            <div className="col-12">
                                                <label
                                                    className="form-label fw-medium mb-1"
                                                    style={{ color: "#495057", fontSize: "0.95rem" }}
                                                >
                                                    Status
                                                </label>
                                                <select
                                                    className="form-select form-select-sm mb-2"
                                                    name="type"
                                                    value={statusFormData.type}
                                                    onChange={handleStatusChange}
                                                >
                                                    <option value="">Select Status</option>
                                                    <option value="complete">Complete</option>
                                                    <option value="work not started">Work Not Started</option>
                                                    <option value="payment done">Payment Done</option>
                                                    <option value="pending">Pending</option>
                                                </select>
                                            </div>
                                            <div className="col-12">
                                                <label
                                                    className="form-label fw-medium mb-1"
                                                    style={{ color: "#495057", fontSize: "0.95rem" }}
                                                >
                                                    Final Payment Amount
                                                </label>
                                                <input
                                                    type="number"
                                                    className="form-control form-control-sm mb-2"
                                                    name="final_payment_amount"
                                                    value={statusFormData.final_payment_amount}
                                                    onChange={handleStatusChange}
                                                />
                                            </div>
                                            <div className="col-12">
                                                <label
                                                    className="form-label fw-medium mb-1"
                                                    style={{ color: "#495057", fontSize: "0.95rem" }}
                                                >
                                                    Unspent Balance
                                                </label>
                                                <input
                                                    type="number"
                                                    className="form-control form-control-sm mb-2"
                                                    name="unspent_balance"
                                                    value={statusFormData.unspent_balance}
                                                    readOnly
                                                    style={{ backgroundColor: "#f8f9fa" }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer" style={{ padding: "10px 20px" }}>
                                    <button
                                        type="button"
                                        className="btn btn-secondary btn-sm"
                                        onClick={() => {
                                            setShowStatusModal(false);
                                            setStatusFormData({
                                                type: "",
                                                final_payment_amount: "",
                                                unspent_balance: "",
                                            });
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button type="submit" className="btn btn-primary btn-sm">
                                        Submit
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {/* Forward/Revert Action Modal */}
            {showActionModal && (
                <div className="modal fade show" style={{ display: "block", background: "rgba(0,0,0,0.5)" }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    {actionType === "forward" ? "Forward" : "Revert"} Memo No: {actionRow?.memo_no}
                                </h5>
                                <button type="button" className="btn-close" onClick={() => setShowActionModal(false)}></button>
                            </div>
                            <form onSubmit={handleActionSubmit}>
                                <div className="modal-body">
                                    <div className="mb-3">
                                        <label className="form-label">Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            name="date"
                                            value={actionFormData.date}
                                            onChange={handleActionFormChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Department</label>
                                        <select
                                            className="form-control"
                                            name="department"
                                            value={actionFormData.department}
                                            onChange={handleActionFormChange}
                                            required
                                        >
                                            <option value="">--Select Department--</option>
                                            {departmentList.map(dept => (
                                                <option key={dept.id} value={dept.id}>{dept.department_name}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">User</label>
                                        <select
                                            className="form-control"
                                            name="user"
                                            value={actionFormData.user}
                                            onChange={handleActionFormChange}
                                            required
                                            disabled={!actionFormData.department}
                                        >
                                            <option value="">
                                                {!actionFormData.department
                                                    ? "--Select Department First--"
                                                    : getActionFilteredUsers().length === 0
                                                        ? "--No Users Available--"
                                                        : "--Select User--"}
                                            </option>
                                            {getActionFilteredUsers().map(user => (
                                                <option key={user.id} value={user.id}>{user.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary btn-sm" onClick={() => setShowActionModal(false)}>
                                        Cancel
                                    </button>
                                    <button type="submit" className="btn btn-primary btn-sm">
                                        Submit
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
            <ToastContainer />
        </>
    );
}

export default Expessense;
